<div class="email-templates-page">

  <!-- Page head -->
  <div class="et-page-head">
    <div>
      <h1><i class="bi bi-envelope-paper" style="color:var(--clug-primary);"></i>Email Templates</h1>
      <p class="lede">Customize colors, copy, and tone of every transactional email sent to candidates,
        clients, and admins. Set brand colors once — they apply across all your templates.</p>
    </div>
  </div>

  <!-- ============================================================
       1) BRANDING CARD
       ============================================================ -->
  <div class="card mainContainer branding-card">
    <div class="card-reminder">
      <h5 class="title"><i class="bi bi-palette-fill" style="color:var(--clug-primary);"></i>Email Branding</h5>
      <span class="reminder-note">Applies to all outgoing emails</span>
    </div>

    <div class="branding-body">
      <div class="brand-fields">

        <div class="brand-field">
          <label><i class="bi bi-droplet-fill"></i>Primary Color</label>
          <div class="color-picker">
            <label class="swatch" [style.background]="branding.primary_color">
              <input type="color" [(ngModel)]="branding.primary_color" (ngModelChange)="onBrandingChange()" />
            </label>
            <input type="text" class="hex" maxlength="7" [(ngModel)]="branding.primary_color"
              (ngModelChange)="onBrandingChange()" />
          </div>
          <span class="hint">Header strip · links · accents</span>
        </div>

        <div class="brand-field">
          <label><i class="bi bi-paint-bucket"></i>Background Color</label>
          <div class="color-picker">
            <label class="swatch" [style.background]="branding.background_color">
              <input type="color" [(ngModel)]="branding.background_color" (ngModelChange)="onBrandingChange()" />
            </label>
            <input type="text" class="hex" maxlength="7" [(ngModel)]="branding.background_color"
              (ngModelChange)="onBrandingChange()" />
          </div>
          <span class="hint">Email body canvas</span>
        </div>

        <div class="brand-field">
          <label><i class="bi bi-square-fill"></i>Button Color</label>
          <div class="color-picker">
            <label class="swatch" [style.background]="branding.button_color">
              <input type="color" [(ngModel)]="branding.button_color" (ngModelChange)="onBrandingChange()" />
            </label>
            <input type="text" class="hex" maxlength="7" [(ngModel)]="branding.button_color"
              (ngModelChange)="onBrandingChange()" />
          </div>
          <span class="hint">Call-to-action button fill</span>
        </div>

        <!-- Phase 2: Footer Text field (needs branding.footer_text from API)
        <div class="brand-field">
          <label><i class="bi bi-card-text"></i>Footer Text</label>
          <input type="text" class="input-form" maxlength="80"
            [(ngModel)]="branding.footer_text" (ngModelChange)="onBrandingChange()" />
          <span class="hint">e.g. "Powered by {agency_name}"</span>
        </div>
        -->

        <div class="brand-actions">
          <button class="btn btn-primary" (click)="saveBranding()" [disabled]="!brandingDirty || brandingSaving">
            <span *ngIf="brandingSaving" class="spinner-border spinner-border-sm me-1"></span>
            <i *ngIf="!brandingSaving" class="bi bi-check2"></i>Save brand
          </button>
          <button class="btn btn-text" *ngIf="brandingDirty && !brandingSaving"
            (click)="discardBranding()">Discard</button>
          <span class="save-flash" [class.show]="brandingSaved"><i class="bi bi-check-circle-fill"></i>Saved</span>
        </div>

      </div>

      <!-- Mini preview swatch -->
      <div class="brand-mini">
        <div class="label">
          <span>Preview</span>
          <span class="label-note">Updates live</span>
        </div>
        <div class="mini-mail" [style.--m-primary]="branding.primary_color" [style.--m-bg]="branding.background_color"
          [style.--m-btn]="branding.button_color">
          <div class="strip"></div>
          <div class="logo">{{ agencyName || 'Your Agency' }}</div>
          <div class="body">
            <div class="h">Welcome aboard, Priya</div>
            <div class="p">Your candidate profile is ready. Tap below to set a password.</div>
            <div>
              <span class="badge-mini">{{ '{first_name}' }}</span>
              <span class="badge-mini">{{ '{agency_name}' }}</span>
            </div>
            <div class="btn-mini">Activate profile</div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- ============================================================
       2) TEMPLATES CARD
       ============================================================ -->
  <div class="card mainContainer tpl-card">
    <div class="loader" *ngIf="loading">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <div class="card-reminder">
      <h5 class="title">
        <i class="bi bi-envelope-paper" style="color:var(--clug-primary);"></i>
        Email Templates
        <span class="count-pill">{{ totalCount }}</span>
      </h5>
      <div class="tpl-toolbar">
        <div class="input-group">
          <i class="bi bi-search"></i>
          <input placeholder="Search templates…" [(ngModel)]="searchQuery" />
        </div>
        <!-- Phase 2: "Edited only" filter (needs is_customized from API)
        <button class="filter-chip" [class.on]="editedOnlyFilter" (click)="editedOnlyFilter = !editedOnlyFilter">
          <i class="bi bi-pencil-square"></i>Edited only
        </button>
        -->
      </div>
    </div>

    <table class="tpl-table" *ngIf="filteredGroups.length > 0">
      <thead>
        <tr>
          <th style="width: 32%;">Template</th>
          <th>Subject</th>
          <th style="width: 130px; text-align: right; padding-right: 22px;">Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let group of filteredGroups">
          <!-- Group header -->
          <tr class="group-row" [class.collapsed]="collapsed[group.key]">
            <td colspan="3">
              <div class="group-bar" (click)="toggleGroup(group.key)">
                <span class="chev"><i class="bi bi-chevron-down"></i></span>
                <span class="g-ico" [ngClass]="group.class"><i class="bi" [ngClass]="group.icon"></i></span>
                <span class="g-title">{{ group.label }}</span>
                <span class="g-count">{{ group.templates.length }}</span>
                <!-- Phase 2: per-group edited indicator -->
              </div>
            </td>
          </tr>

          <!-- Template rows -->
          <tr class="tpl-row" *ngFor="let template of group.templates" [class.hidden]="collapsed[group.key]"
            (click)="editTemplate(template)">
            <td>
              <div class="label-cell">
                <span class="label">{{ template.label }}</span>
                <!-- Phase 2: <span class="edited-tag">Edited</span> -->
              </div>
            </td>
            <td>
              <div class="subject-cell" [title]="template.subject">{{ template.subject }}</div>
            </td>
            <td class="actions-cell">
              <button type="button" class="btn-icon-sq" title="Edit template"
                (click)="$event.stopPropagation(); editTemplate(template)">
                <i class="bi bi-pencil"></i>
              </button>
              <button type="button" class="btn-icon-sq warn" title="Reset to default"
                (click)="$event.stopPropagation(); resetTemplate(template)">
                <i class="bi bi-arrow-counterclockwise"></i>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <!-- Empty state -->
    <div class="et-empty" *ngIf="!loading && filteredGroups.length === 0">
      <div class="ico"><i class="bi bi-envelope-slash"></i></div>
      <h3>No templates match your search</h3>
      <p>Try a different keyword, or clear the filter.</p>
      <button class="btn btn-secondary" (click)="clearFilters()"><i class="bi bi-x-lg"></i>Clear filters</button>
    </div>
  </div>

</div>